import { useQuery, useMutation } from "@tanstack/react-query";
import clienteAxios from "../../helpers/clienteAxios";
import { useLoading } from "../../context/loadingContext";

const apiGetDisponibilidadAgendamientos = async (params) => {
    const { data } = await clienteAxios.get("/sucursalVirtual/integracionAtec/disponibilidadAgendamiento", { params });
    return data;
};

const useGetDisponibilidadAgendamientos = (params) => {
    const { setLoading, removeLoading } = useLoading();

    return useMutation(apiGetDisponibilidadAgendamientos, {
        onSuccess: (response) => {
            removeLoading({
                id: "disponibilidadAgendamiento",
            });
        },
        onError: (error) => {
            removeLoading({
                id: "disponibilidadAgendamiento",
            });
        },
        onMutate: () => {
            setLoading({
                id: "disponibilidadAgendamiento",
            });
        }
    });

    return result;
};

export default useGetDisponibilidadAgendamientos